module.exports = __webpack_public_path__ + "Notification-3l0woFq.svg";